import { MapContainer } from 'react-leaflet';
import styled from 'styled-components';

const MapWrapper = styled(MapContainer)`
  width: 100%;
  height: 100%;
  border: 2px solid ${p => p.theme.colors.border};
  z-index: 0;

  /* Zoom control styles */
  .leaflet-control-zoom {
    border: 4px solid rgba(255, 255, 255, 1);

    a {
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 0 !important;
    }
  }

  /* Leaflet layer control styles */
  .leaflet-control-layers {
  border: none;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);

    &.leaflet-control-layers-minimap.leaflet-control {
      width: unset;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
      border: 4px solid rgba(255, 255, 255, 1);

      /* Layers group button icon */
      .leaflet-control-layers-toggle {
        width: 32px;
        height: 32px;

        &::after {
          display: block;
          text-rendering: auto;
          -webkit-font-soothing: antialiased;

          font-family: 'Font Awesome 6 Pro';
          font-weight: 400;
          content: '\f5fd';

          color: #000;
          font-size: 20px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .leaflet-control-layers-list {
        .leaflet-control-layers-base {
          display: flex;
          gap: 5px;

          /* Layer 'minimap' */
          .leaflet-minimap-container {
            width: 30px;
            height: 30px;

            .leaflet-minimap-label {
              background-color: transparent;

              span {
                display: none;
              }

              /* Selected layer icon */
              .leaflet-control-layers-selector {
                visibility: hidden;

                &:checked {
                  &::after {
                    visibility: visible;
                    display: block;
                    text-rendering: auto;
                    -webkit-font-soothing: antialiased;

                    font-family: 'Font Awesome 6 Pro';
                    font-weight: 400;
                    content: '\f00c';
                    width: 20px;
                    height: 20px;
                    background-color: ${p => p.theme.colors.theme};
                    border-radius: 50%;
                    padding: 4px;
                    transform: translate(3px, -50%);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default MapWrapper;
